import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { ScrollingProvider } from 'react-scroll-section';
import Helmet from './Helmet';
import StaticHeader from './StaticHeader';
import Footer from './Footer';

import { Flex, Box } from 'rebass/styled-components';
import { createGlobalStyle, ThemeProvider } from 'styled-components';
import theme from '../../theme';

const GlobalStyle = createGlobalStyle`
  *,
  *::after,
  *::before {
    box-sizing: inherit;
    }

  body {
    box-sizing: border-box;
    margin: 0;
    font-family: Poppins, sans-serif;
    font-size: 14px;
    color: #4F4A55;
    line-height: 23px;
    font-display: swap;
    overflow-x: hidden;
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: subpixel-antialiased;
  }

  img {
    max-width: 520px;
  }
`;

const Layout = ({ children, onClick }) => {
  return (
    <Fragment>
      <GlobalStyle />
      <ThemeProvider theme={theme}>
        <ScrollingProvider>
          <Helmet />
          <Flex
            justifyContent="space-between"
            alignItems="center"
            flexDirection="column"
            minHeight={'100vh'}
            bg="#d7e0e1"
          >
            <Box width={['100%', '600px']} bg="white">
              <StaticHeader onClick={onClick} />
              {children}
            </Box>
            <Box width={['100%', '600px']} bg="white">
              <Footer />
            </Box>
          </Flex>
        </ScrollingProvider>
      </ThemeProvider>
    </Fragment>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired
};

export default Layout;
